import React from 'react'
import '../../loader.css'

const Loader = ({ show, message, overlay }) => {
    return (
        <div className={`loader-wrapper ${show ? 'show' : ''}`}>
            <div className='loader items-center gap-2'>
                <div>
                    <img src={'/loader-new.gif'} width={40} height={40} alt='icon' />
                </div>
                <div className='grow'>
                    <p>{message}</p>
                </div>
            </div>
            {overlay ? <div className={`loader-overlay ${show ? 'show' : ''}`}></div> : null}
        </div>
    )
}

export default Loader